// Editorial Warm icon set — single-color stroke SVGs ported verbatim
// from tmp/handoff/design/Nala Home.html (`shared.jsx`).
//
// Each icon takes `size` and `color` (defaulting to `currentColor`) so it
// can adopt the surrounding text color without prop plumbing. `Star`
// additionally accepts `fill` so the same component can render hollow
// outlines and filled rating stars.

interface IconProps {
  size?: number
  color?: string
}

interface StarProps extends IconProps {
  fill?: string
}

export const NalaIcon = {
  Paw: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <ellipse cx="6" cy="9" rx="1.6" ry="2.2" fill={color} stroke="none" />
      <ellipse cx="10" cy="6" rx="1.6" ry="2.2" fill={color} stroke="none" />
      <ellipse cx="14" cy="6" rx="1.6" ry="2.2" fill={color} stroke="none" />
      <ellipse cx="18" cy="9" rx="1.6" ry="2.2" fill={color} stroke="none" />
      <path d="M12 11c-3 0-5 2-5 4.5 0 2 1.5 3 3 3 .8 0 1.3-.4 2-.4s1.2.4 2 .4c1.5 0 3-1 3-3 0-2.5-2-4.5-5-4.5z" fill={color} stroke="none" />
    </svg>
  ),
  Home: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /><path d="M10 20v-6h4v6" />
    </svg>
  ),
  Calendar: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 9h18" /><path d="M8 3v4" /><path d="M16 3v4" />
    </svg>
  ),
  Heart: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.5-7 10-7 10z" />
    </svg>
  ),
  Stethoscope: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 4v6a4 4 0 0 0 8 0V4" /><path d="M9 14v3a4 4 0 0 0 8 0v-1" /><circle cx="17" cy="13" r="2" />
    </svg>
  ),
  Tooth: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 3c-2 0-3 2-3 4 0 3 1 4 1.5 7l1 6c.2 1 1.5 1 1.7 0l1-5c.2-1 1.4-1 1.6 0l1 5c.2 1 1.5 1 1.7 0l1-6c.5-3 1.5-4 1.5-7 0-2-1-4-3-4-1.5 0-2 1-3.5 1S8.5 3 7 3z" />
    </svg>
  ),
  Syringe: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 2l4 4" /><path d="M15 5l4 4" /><path d="M11 9l4 4" /><path d="M3 21l8-8" /><path d="M7 17l-2 2" />
    </svg>
  ),
  Chip: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <rect x="6" y="6" width="12" height="12" rx="2" /><path d="M9 3v3M15 3v3M9 18v3M15 18v3M3 9h3M3 15h3M18 9h3M18 15h3" />
    </svg>
  ),
  Phone: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" />
    </svg>
  ),
  Scan: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 7V5a2 2 0 0 1 2-2h2" /><path d="M17 3h2a2 2 0 0 1 2 2v2" /><path d="M21 17v2a2 2 0 0 1-2 2h-2" /><path d="M7 21H5a2 2 0 0 1-2-2v-2" /><path d="M7 12c1.5-2 3-2 5-2s3.5 0 5 2" /><path d="M8 16c1-1.2 2.2-1.5 4-1.5s3 .3 4 1.5" />
    </svg>
  ),
  Leaf: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 19c0-7 5-13 14-13 0 9-6 14-13 14" /><path d="M5 19l8-8" />
    </svg>
  ),
  Pin: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s7-7 7-12a7 7 0 0 0-14 0c0 5 7 12 7 12z" /><circle cx="12" cy="10" r="2.5" />
    </svg>
  ),
  Plane: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 2 11 13" /><path d="M22 2 15 22 11 13 2 9 22 2z" />
    </svg>
  ),
  HeartPulse: ({ size = 18, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
      <path d="M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27" />
    </svg>
  ),
  Arrow: ({ size = 16, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14" /><path d="M13 6l6 6-6 6" />
    </svg>
  ),
  Check: ({ size = 16, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12l5 5L20 7" />
    </svg>
  ),
  Plus: ({ size = 14, color = 'currentColor' }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
  Star: ({ size = 14, color = 'currentColor', fill = 'currentColor' }: StarProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} stroke={color} strokeWidth="1.4" strokeLinejoin="round">
      <path d="M12 3l2.6 5.6 6 .7-4.4 4.2 1.2 6L12 16.7 6.6 19.5l1.2-6L3.4 9.3l6-.7z" />
    </svg>
  ),
} as const

export type NalaIconName = keyof typeof NalaIcon
